import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { getTopModal, popModal, pushModal } from "utils/modalStack"

export default function useBackListener(
  show: boolean,
  handleBackCallback: () => void,
  handleUnmountCallback?: () => void
) {
  const location = useLocation()

  useEffect(() => {
    if (!show) return

    const id = pushModal(handleBackCallback, handleUnmountCallback)

    const handleBack = (event: PopStateEvent) => {
      const topModal = getTopModal()
      if (topModal?.id === id) {
        event.preventDefault()
        handleBackCallback()
      }
    }

    window.history.pushState(null, "", location.pathname)
    window.addEventListener("popstate", handleBack)

    return () => {
      popModal(id)
      window.removeEventListener("popstate", handleBack)
    }
  }, [show, location.pathname])
}
